import { StyleSheet } from "aphrodite";
import { borderColor } from "main/javascripts/styles/base/colorStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";

export interface IStyle {
  block: any;
  imageListBlock: any;
  basicInfoBlock: any;
  reviewListBlock: any;
  stepIndicatorBlock: any;
}

export const MainStyle: IStyle = StyleSheet.create({
  block: {
    paddingTop: 0,
    cursor: "pointer",
  },
  imageListBlock: {
    padding: `0 0 ${space.atom}`,
  },
  basicInfoBlock: {
    padding: `${space.atom}`,
  },
  reviewListBlock: {
    padding: `0 ${space.atom} ${space.atom3x} ${space.atom}`,
    ":before": {
      content: "''",
      display: "block",
      borderTop: `1px solid ${borderColor.secondaryLightColor}`,
      margin: `0 ${space.atom} ${space.atom3x}`,
    },
  },
  stepIndicatorBlock: {
    paddingBottom: space.atom3x,
  },
});
